// extracted by mini-css-extract-plugin
export default {"container":"S0-z","heading":"T0-z","links":"U0-z","copy":"V0-z","subCopy":"W0-z","linksLeft":"X0-z","linksCenter":"Y0-z","linksRight":"Z0-z","link":"_0-z","onlyLink":"a1-z"};